import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getPowTourPrvsMngManagements: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.powLnCd !== undefined) {
			queryStr = objectToQuerystring({
				powLnCd: searchParams.powLnCd,
				currentPage,
				pageUnit
			});
		}
		return client
			.get(`${BASE_URL}/pqy/ptin/powTourPrvsMng/v1/powTourPrvsMngs` + queryStr)
			.then(response => response?.data)
			.catch(error => {
				throw error?.response?.data;
			});
	},
	postPowTourPrvsMngManagement: param => {
		//console.log('debug', param);
		return client
			.post(`${BASE_URL}/pqy/ptin/powTourPrvsMng/v1/status/${param.status}`, param.data)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	/**필터된 발생공장 코드만을 가져온다 param type : object */
	// custom 코드조회
	async getPowPrvsCdFiltered(codeType) {
		try {
			const params = { commCdType: codeType, sqlId: 'custDescSql_4', commCd: '', refCd: '' };
			const queryString =
				'?' +
				Object.entries(params)
					.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
					.filter(r => r)
					.join('&');
			//console.log(`${BASE_URL}/comm/common/custCode/v1/custCodeLists` + queryString);
			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/custCodeLists` + queryString);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async excelTempDown(params) {
		// 엑셀템플릿 다운로드
		try {
			const response = await client.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downExcelTemp`, params, {
				responseType: 'blob'
			});
			return response;
		} catch (error) {
			//throw error.response?.data;
			throw new Error(error.response?.data);
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce() {
		try {
			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/powTourCodeLists`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/**한번에 구분 없이 한번에 공통 코드 부르기 */
	async getMergedCommCodesOnce(codes) {
		try {
			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/noCategoryLists?codes=${codes}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
